/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Button } from '../button/button';

export const Container = (props) => (
  <section
    sx={{
      padding: ['8rem 4vw 0', '9.8rem 4vw 0', '7.6rem 6.4rem 0'],
      px: ['1.4rem', '2.8rem', '6.4rem'],
      backgroundColor: 'White',
      position: 'relative',
      '> *': {
        maxWidth: '100rem',
      },
      '&:before': {
        content: '""',
        height: '1px',
        bg: 'SecondaryGray3',
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
      },
    }}
    {...props}
  />
);

export const Header = (props) => (
  <div
    sx={{
      h1: {
        fontWeight: 400,
        color: 'SecondaryBlue2',
        mb: '1rem',
      },
      p: {
        color: 'PrimaryDarkBlue',
      },
    }}
    {...props}
  />
);

export const FeaturedLink = (props) => (
  <Button
    sx={{
      position: 'relative',
      bottom: '-3.2rem',
    }}
    {...props}
  />
);
